import Vue from 'vue';
import { Emit, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import EdInputModel from '@/models/ed-input.model';

@Component({
  name: 'ed-scan-document-modal',
  components: {
  }
})
export default class EdScanDocumentModal extends Vue {

  @Prop() readonly params: any;

  isCameraOpen: boolean = true;
  isPhotoTaken: boolean = false;
  isShotPhoto: boolean = false;
  isLoading: boolean = false;
  saveAsPdf: any = EdInputModel('saveAsPdf', false, {}, true);
  filePicture: any;
  useFrontCamera :boolean = false;
  videoWidth = 0;
  videoHeight = 0;

  get typeOfCamera() {
    return this.useFrontCamera ? 'user' : 'environment';
  }

  createCameraElement() {
    this.isLoading = true;

    navigator.mediaDevices.getUserMedia({
      audio: false,
      video: { facingMode: this.typeOfCamera }
    })
      .then(this.gotMedia)
      .catch(error => {
        this.isLoading = false;
      });
  }

  gotMedia(mediaStream) {
    const camera: any = this.$refs.camera;
    
    camera.srcObject = mediaStream;
    camera.onloadedmetadata = () => {
      this.videoWidth = camera.videoWidth;
      this.videoHeight = camera.videoHeight;
    };

    this.isLoading = false;
  }
  
  processPhoto(img, blob) {
    img.src = window.URL.createObjectURL(blob);

    // Scale the video width and video height to 150px of width to image
    const scaleFactor = this.videoWidth / 150;
    const imageWidth = this.videoWidth / scaleFactor;
    const imageHeight = this.videoHeight / scaleFactor;

    img.style.width = `${imageWidth}px`;
    img.style.height = `${imageHeight}px`;
    
    this.stopCameraStream();
    this.filePicture = blob;
    this.params.onChangeFile({file: blob, saveAsPdf: this.saveAsPdf.value});
  }

  capture() {
    const canvas : any = document.getElementById('photoTaken');
    const video : any = document.getElementById('videoScan');

    canvas.width = this.videoWidth;
    canvas.height = this.videoHeight;

    canvas
      .getContext('2d')
      .drawImage(video, 0, 0, this.videoWidth, this.videoHeight);
  
    const playImage = new Image();
    playImage.src = 'path to image asset';
    playImage.onload = () => {
      const startX = this.videoWidth / 2 - playImage.width / 2;
      const startY = this.videoHeight / 2 - playImage.height / 2;
      canvas
        .getContext('2d')
        .drawImage(playImage, startX, startY, playImage.width, playImage.height);
    };

    canvas.toBlob((blob) => {
      var img = document.getElementById('imageScan');
      this.processPhoto(img, blob);

    });
  }

  takePhoto() {
    if(!this.isPhotoTaken) {
      this.isShotPhoto = true;
      this.params.isShotPhotoChange(this.isShotPhoto);

      const FLASH_TIMEOUT = 50;

      setTimeout(() => {
        this.isShotPhoto = false;
        this.params.isShotPhotoChange(this.isShotPhoto);
      }, FLASH_TIMEOUT);
    }
    
    this.capture();
    this.closeCamera();
    this.isPhotoTaken = !this.isPhotoTaken;
    this.params.isPhotoTakenChange(this.isPhotoTaken);
  }

  public closeCamera() {
    this.isCameraOpen = false;
    this.params.onChangeCameraOpen(this.isCameraOpen);
    this.isPhotoTaken = false;
    this.params.isPhotoTakenChange(this.isPhotoTaken);
    this.isShotPhoto = false;
    this.params.isShotPhotoChange(this.isShotPhoto);
    this.stopCameraStream();
    this.$EdModal.closeBootstrapModal();
  }

  stopCameraStream() {
    let camera : any = this.$refs.camera;
    if(camera) {
      let tracks = camera.srcObject.getTracks();

      tracks.forEach(track => {
        track.stop();
      });
    }
  }

  changeCamera() {
    this.isPhotoTaken = false;
    this.isShotPhoto = false;
    this.params.isPhotoTakenChange(this.isPhotoTaken);
    this.params.isShotPhotoChange(this.isShotPhoto);
    this.stopCameraStream();
    this.useFrontCamera = !this.useFrontCamera;
    this.createCameraElement();
  }

  mounted() {
    this.createCameraElement();
    this.params.onChangeCameraOpen(this.isCameraOpen);
  }

  destroyed () {
    this.params.onChangeCameraOpen(false);
  }

}
